/* ESCUDO EE. UU. (tienda Cupresse, 2026-10-14) — misma lógica de página que page-escudo.js de Colombia
   (galería, colores, combos con mezcla de colores, barra fija), pero con PAGO ANTICIPADO:
   el botón vacía el carrito, carga una línea por color con su cantidad y abre el checkout de Shopify.
   Los combos de 2 y 3 kits los cobra el checkout con los descuentos automáticos 'ESCUDO Combo x2 / x3',
   que cuentan unidades de cualquier color: mezclar colores no cambia el precio.
   Textos del JS en window.ESCUDO_T y variantes en window.ESCUDO_VARIANTS (los pone sections/escudo-landing.liquid). */
var ESC = { qty: 1, colores: ['black', 'black', 'black'], busy: false };
function escT(){ return window.ESCUDO_T || { names: {} }; }
function escName(c){ return escT().names[c] || c; }
function escCombo(){ return ESC.colores.slice(0, ESC.qty); }
function escAviso(txt){
  var t = document.getElementById('es-wait');
  if (!t) { t = document.createElement('div'); t.id = 'es-wait';
    t.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);z-index:2147483000;background:#121211;color:#f4f1ea;font:600 14px/1.3 Inter,-apple-system,sans-serif;padding:13px 20px;border-radius:999px;box-shadow:0 6px 24px rgba(0,0,0,.25);transition:opacity .3s;pointer-events:none;max-width:90vw;text-align:center';
    document.body.appendChild(t); }
  if (txt) t.textContent = txt;
  t.style.opacity = txt ? '1' : '0';
}
function openOrder(){
  if (ESC.busy) return;
  var T = escT(), V = window.ESCUDO_VARIANTS || [];
  // ningún color disponible = el visitante está fuera de EE. UU. (el perfil de envío de ESCUDO solo cubre EE. UU.)
  if (!V.some(function(o){ return o.available; })) { escAviso(T.usOnly); setTimeout(function(){ escAviso(''); }, 4500); return; }
  // una línea por color; los colores repetidos van en una sola línea con su cantidad
  var items = [], idx = {};
  for (var x = 0; x < ESC.qty; x++) {
    var c = ESC.colores[x], v = V.filter(function(o){ return String(o.sku).toUpperCase() === 'ESCUDO-' + c.toUpperCase(); })[0];
    if (!v || !v.available) { escAviso(T.soldout); setTimeout(function(){ escAviso(''); }, 3500); return; }
    if (v.id in idx) items[idx[v.id]].quantity++;
    else {
      // el regalo queda escrito en la línea del pedido: un cuello-máscara del mismo color por cada sombrero
      var props = {}; if (T.giftProp) props[T.giftProp] = T.giftVal(escName(c));
      idx[v.id] = items.length; items.push({ id: v.id, quantity: 1, properties: props });
    }
  }
  var root = String(window.ESCUDO_ROOT || '/').replace(/\/$/, '');
  var post = function(path, body){ return fetch(root + path, { method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}) })
    .then(function(r){ if (!r.ok) throw new Error(path + ' ' + r.status); return r.json(); }); };
  ESC.busy = true;
  escAviso(T.preparing);
  post('/cart/clear.js')
    .then(function(){ return post('/cart/add.js', { items: items }); })
    .then(function(){ window.location.href = root + '/checkout'; })
    .catch(function(e){
      console.warn('[escudo] pedido:', e);
      ESC.busy = false;
      escAviso(T.fail);
      setTimeout(function(){ escAviso(''); }, 4500);
    });
}
// si vuelven desde el checkout con el botón Atrás, la página sale del bfcache con el aviso puesto
window.addEventListener('pageshow', function(){ ESC.busy = false; escAviso(''); });
(function(){
  const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
  const T=escT();

  // cuenta regresiva REAL al fin del precio de lanzamiento (31 oct, 23:59 hora del este)
  const end=new Date('2026-11-01T03:59:59Z').getTime(), cd=$('#esCd');
  const tick=()=>{let s=Math.max(0,Math.round((end-Date.now())/1e3));if(!s){cd.textContent='';return}const d=Math.floor(s/86400);s%=86400;
    cd.textContent=(d?d+'d ':'')+String(Math.floor(s/3600)).padStart(2,'0')+':'+String(Math.floor(s%3600/60)).padStart(2,'0')+':'+String(s%60).padStart(2,'0')};
  tick();setInterval(tick,1000);

  function car(track,onIdx){
    const items=[...track.children];
    const idx=()=>{const l=track.getBoundingClientRect().left+(parseFloat(getComputedStyle(track).paddingLeft)||0);let b=0,d=1e9;items.forEach((it,i)=>{const x=Math.abs(it.getBoundingClientRect().left-l);if(x<d){d=x;b=i}});return b};
    track.addEventListener('scroll',()=>onIdx&&onIdx(idx(),items.length),{passive:true});
    return{go:i=>{i=(i+items.length)%items.length;track.scrollTo({left:items[i].offsetLeft-items[0].offsetLeft,behavior:'smooth'})},idx,n:items.length};
  }

  // galería
  const gt=$('#esGal'), slides=[...gt.children], dots=$('#esGalDots');
  dots.innerHTML=slides.map((_,i)=>'<i'+(i?'':' class="on"')+'></i>').join('');
  $('#esThumbs').innerHTML=slides.map((s,i)=>'<div class="es-ph'+(i?'':' on')+'"><img loading="lazy" src="'+s.querySelector('img').getAttribute('src')+'" alt=""></div>').join('');
  const gal=car(gt,(i,n)=>{[...dots.children].forEach((d,j)=>d.classList.toggle('on',j===i));$$('#esThumbs .es-ph').forEach((t,j)=>t.classList.toggle('on',j===i));$('#esGalN').textContent=(i+1)+' / '+n});
  $('#esGalN').textContent='1 / '+slides.length;
  $$('.es-gal-arr').forEach(b=>b.onclick=()=>gal.go(gal.idx()+ +b.dataset.dir));
  $$('#esThumbs .es-ph').forEach((t,i)=>t.onclick=()=>gal.go(i));

  // colores: el selector principal pone TODOS los sombreros en ese color; en 2 y 3 kits se mezclan fila por fila
  const COLS=$$('#esSw button').map(b=>b.dataset.c);
  const swImg=c=>{const i=$('#esSw button[data-c="'+c+'"] img');return i?i.src:''};
  const uniq=()=>escCombo().filter((c,i,a)=>a.indexOf(c)===i);
  const renderMix=()=>{const box=$('#esMix');box.hidden=ESC.qty<2;if(ESC.qty<2)return;
    $('#esMixRows').innerHTML=escCombo().map((c,i)=>'<div class="es-mix-row" data-i="'+i+'"><span>'+T.hat+' '+(i+1)+'<small>'+(T.kit?T.kit(escName(c)):escName(c))+'</small></span><div class="es-mix-opts">'+
      COLS.map(o=>'<button type="button" data-c="'+o+'"'+(o===c?' class="on"':'')+' aria-label="'+T.hat+' '+(i+1)+' '+T.in+' '+escName(o)+'"><img src="'+swImg(o)+'" alt=""></button>').join('')+'</div></div>').join('')};
  const sync=()=>{const q=$('.es-q.on'),u=uniq();
    $$('#esSw button').forEach(x=>x.classList.toggle('on',x.dataset.c===ESC.colores[0]));
    $('#esColLbl').textContent=u.map(escName).join(' + ');
    const sl=slides.find(x=>x.dataset.c===ESC.colores[0]);$('#esStImg').src=(sl||slides[0]).querySelector('img').src;
    $('#esStL').textContent=q.querySelector('.es-q-n').textContent+' · '+(u.length>2?u.length+' '+T.colors:u.map(escName).join(' + '));
    $('#esStP').textContent=q.dataset.price;renderGift();renderMix()};
  // regalo: un cuello-máscara por sombrero, cada uno del color de su sombrero
  const renderGift=()=>{const g=window.ESCUDO_GAITER||{},cols=escCombo(),u=uniq(),n=cols.length,box=$('#esGiftImgs');if(!box)return;
    box.innerHTML=cols.map(c=>'<img src="'+(g[c]||'')+'" alt="">').join('');box.dataset.n=n;
    $('#esGiftT').textContent=n>1?n+T.giftN:T.gift1;
    $('#esGiftS').textContent=u.map(escName).join(' + ')+' · '+(n>1?T.giftMatchN:T.giftMatch1)};
  $$('#esSw button').forEach(b=>b.onclick=()=>{ESC.colores=[b.dataset.c,b.dataset.c,b.dataset.c];
    const k=slides.findIndex(s=>s.dataset.c===b.dataset.c);if(k>=0)gal.go(k);sync()});
  $('#esMixRows').addEventListener('click',e=>{const b=e.target.closest('button[data-c]');if(!b)return;
    ESC.colores[+b.closest('.es-mix-row').dataset.i]=b.dataset.c;sync()});

  // cantidad: el precio de arriba y el de la barra fija siguen al combo elegido
  const qs=$$('.es-q');
  const setQ=q=>{qs.forEach(x=>x.classList.toggle('on',x===q));q.querySelector('input').checked=true;ESC.qty=+q.dataset.qty;
    $('#esPrice').textContent=q.dataset.price;
    const cm=$('#esCmp');cm.textContent=q.dataset.cmp||'';cm.hidden=!q.dataset.cmp;
    const sv=$('#esSave');sv.textContent=q.dataset.save;sv.style.display=q.dataset.save?'':'none';
    $('#esPer').textContent=q.dataset.per+' · '+T.freeShip;sync()};
  qs.forEach(q=>q.addEventListener('click',()=>setQ(q)));
  setQ($('.es-q.on')||qs[0]);

  // entrega: sin fechas exactas hasta confirmar los días reales de envío en EE. UU. (queda el texto fijo de #esDlv)

  // planes
  const pl=car($('#esPl'),(i,n)=>$('#esPlN').textContent=(i+1)+' / '+n);
  $$('[data-pl]').forEach(b=>b.onclick=()=>pl.go(pl.idx()+ +b.dataset.pl));

  // barra fija: SIEMPRE visible desde que abre la página, en celular y computador
  sync();
})();
